import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    headerDescription:
      'Because Shine is a regulated financial institution, we’re required to ask these questions before opening your account:',
    linkLabelKnowMore: 'I want to know more',
  },
  fr: {
    headerDescription:
      'Shine est un établissement financier. La régulation bancaire nous impose de vous poser quelques questions avant d’ouvrir votre compte\u00A0:',
    linkLabelKnowMore: 'En savoir plus',
  },
});
